module.exports = __webpack_public_path__ + "img/plane-despegar.02f0857b.svg";